import styled from '@emotion/styled';

export const CardContainer = styled.div`
	padding: 3.2rem 2.8rem;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	gap: 1.6rem;
	min-height: 24rem;
	height: 100%;
	background-color: #fff;
	border: 1px solid ${(props) => props.theme.colors.gray100};
	border-radius: ${(props) => props.theme.effects.radiusLg};
	box-shadow: ${(props) => props.theme.effects.shadowSm};
	cursor: pointer;
	transition:
		transform ${(props) => props.theme.effects.transitionBase},
		box-shadow ${(props) => props.theme.effects.transitionBase},
		background-color ${(props) => props.theme.effects.transitionBase},
		border-color ${(props) => props.theme.effects.transitionBase};

	.card-arrow {
		transition: transform ${(props) => props.theme.effects.transitionBase};
	}

	&:hover {
		transform: translateY(-0.4rem);
		box-shadow: ${(props) => props.theme.effects.shadowMd};
		border-color: ${(props) => props.theme.colors.primary100};

		.card-arrow {
			transform: translateX(0.6rem);
		}
	}

	&.dark {
		background: linear-gradient(145deg, ${(props) => props.theme.colors.brandNavy} 0%, #0a2d5c 100%);
		border-color: ${(props) => props.theme.colors.brandNavy};
		color: #fff;
		box-shadow: ${(props) => props.theme.effects.shadowMd};

		p {
			color: rgba(255, 255, 255, 0.85);
		}

		img:not(.card-arrow) {
			filter: brightness(0) invert(1);
			transition: transform ${(props) => props.theme.effects.transitionBase};
		}

		&:hover {
			background: linear-gradient(145deg, ${(props) => props.theme.colors.brandNavyHover} 0%, #0d3870 100%);
			border-color: ${(props) => props.theme.colors.brandNavyHover};
			box-shadow: ${(props) => props.theme.effects.shadowLg};

			img:not(.card-arrow) {
				transform: scale(1.05);
			}
		}

		.card-arrow {
			filter: brightness(0) invert(1);
		}
	}

	@media screen and (max-width: 1100px) {
		padding: 2.8rem 2.4rem;
		min-height: 20rem;
	}
`;
